import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const getProducts = async (page) => {
  try {
    const { data } = await _axios.get(`/api/products?depth=1${page ? `&page=${page}` : ""}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const getProductsFiltered = async (sortProp, page, queryObj) => {
  const stringifiedQuery = Object.keys(queryObj).length
    ? qs.stringify({ where: queryObj })
    : "";

  try {
    const { data } = await _axios.get(`/api/products?depth=1&page=${page}` +
      (stringifiedQuery ? `&${stringifiedQuery}` : "") +
      (sortProp ? `&sort=${sortProp}` : ""));
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const createProduct = async (props) => {
  try {
    IS_LOCAL_ENV && console.log("creando producto");
    const { data } = await _axios.post(`/api/products`, props);
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const updateProduct = async (productId, updatedProps) => {
  try {
    IS_LOCAL_ENV && console.log("actualizando producto");
    const { data } = await _axios.patch(`/api/products/${productId}`, { ...updatedProps });
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const deleteProduct = async (productId) => {
  try {
    const { data } = await _axios.delete(`/api/products/${productId}`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const getImages = async () => {
  try {
    const { data } = await _axios.get(`/api/productPhotos?limit=0&depth=1`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const getImagesBySubClass = async (subClassId) => {

  const stringifiedQuery = qs.stringify({
    where: {
      subClass: {
        equals: subClassId
      }
    }
  }, {
    addQueryPrefix: true
  });

  try {
    const { data } = await _axios.get(`/api/productPhotos${stringifiedQuery}&limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
  }
}

export const getAllSubClasses = async () => {
  try {
    let { data } = await _axios.get(`/api/productSubClasses?limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const uploadProductImage = async (props) => {
  try {
    const formData = new FormData();
    formData.append("alt", "imagen de producto");
    formData.append("file", props.file);
    formData.append("isMainImage", props.isMainImage);
    formData.append("subClass", props.subClass);

    const { data } = await _axios.post(`/api/productPhotos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data.doc;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const getTutorials = async () => {
  try {
    const { data } = await _axios.get(`/api/tutorials?limit=0`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const handleBulkCreate = async (products) => {
  try {
    const { data } = await _axios.post("/api/bulkCreateProducts", products);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw new Error("Error al cargar productos.");
  }
};

// export const updateSCMainSpecs = async (scId, specs) => {
//   try {
//     const { data } = await _axios.patch(`/api/productSubClasses/${scId}`, {
//       mainSpecs: specs,
//     });
//     return data;
//   }
//   catch (err) {
//     IS_LOCAL_ENV && console.error(err);
//     throw new Error("Error al actualizar especificaciones de producto.");
//   }
// };